import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import LoginPage from './pages/LoginPage';
import DoctorDashboard from './pages/DoctorDashboard';
import DoctorRoute from './pages/DoctorRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/doctor/login" element={<LoginPage />} />
          <Route element={<DoctorRoute />}>
            <Route path="/doctor/dashboard" element={<DoctorDashboard />} />
          </Route>
          {/* Redirect base path to login */}
          <Route path="/" element={<Navigate to="/doctor/login" replace />} />
        </Routes>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </AuthProvider>
  );
}

export default App;
